import { MediaDeviceManager } from 'utils/ui/media';
import { userSession } from './session';
import { isDebugMode } from 'utils/ui/debug';

let state: MediaDeviceManager;

let lastId: string | undefined;

export function myCameraStream() {
  if (lastId !== userSession().get('id')) {
    // restart media manager for each 3d exhibition session to allow proper cleanup
    state?.destroy();
    state = undefined!;
  }

  if (!state) {
    state = new MediaDeviceManager();

    lastId = userSession().get('id');

    state.once('before-initialized', () => {
      if (!userSession().voipEnabled) {
        // Do not allow audio/video to start unless we are using remote session
        return false;
      }
    });

    state.once('initialized', () => {
      userSession().once('session:end', () => {
        state.enableTrack('audio', false);
        state.enableTrack('video', false);
        state.destroy();

        // dump instance to allow garbage collection
        // this looks like the reset from a few lines above, but they don't always duplicate
        state = undefined!;
      });
    });
  }
  return state;
}

if (isDebugMode()) {
  window.myCameraStream = myCameraStream;
}
